export default __webpack_public_path__ + "static/media/baby2.e094226f.png";